import React from "react";
import books from "../assets/books.png";
import { Link } from "react-router-dom";
const Home = () => {
  return (
    <div className="font-main">
      <div className="flex flex-col flex-wrap justify-center items-center min-h-[90vh] h-fit w-[100vw] bg-no-repeat bg-cover bg-[url('/src/assets/hero.png')]">
      <h1 className="font-main text-[7rem] text-center text-black"><span className="text-white">Educate</span> The Future</h1>
        <h1 className="my-14 text-6xl text-center text-white">
          A place you can rely to support kids.
        </h1>
        <div className="my-14">
          <Link to='/misc'><button className="mx-12 my-4 w-64 h-24 bg-black text-white rounded-[40px] text-5xl">
            View
          </button></Link>
    <Link to='/icongen'><button className="mx-12 my-4 w-64 h-24 bg-black text-white rounded-[40px] text-3xl">
            Icon Generator (New)
          </button></Link>
          <Link to='/request'><button className="mx-12 my-4 w-64 h-24 border-[6px] border-black rounded-[40px] text-5xl bg-white">
            Request/Add
          </button></Link>
        </div>
      </div>
      <div className="p-8">
        <h1 className="text-8xl text-center text-">About</h1>
        <div className="flex flex-wrap justify-evenly m-12 min-h-[90vh] items-center">
          <p className="w-1/2 lg:w-11/12 lg:text-4xl text-6xl m-4">
            
            The goal of this website is to provide resources for teachers and
            parents who have students or kids who have disabilities. This website
            provides resources and other supplements to teach your little ones important life
            skills. Check out the different resources we have in a variety of
            subjects such as math, writing and reading. Also if you do not find a resource
            that you are looking for, make a request in the form available on our website.
          </p>
          <img
            className='m-4'
            alt="A stack of five books in five different colors."
            src={books}
          />
        </div>
      </div>
              <div className='text-center text-3xl p-4'> Made by <a target="_blank" href='https://nanditarajkumar.vercel.app'><span className='underline'>Nandita Raj Kumar</span></a> © 2024 </div>
    </div>
  );
};

export default Home;
